import { useId, useState } from 'react';
import { NJButton, NJHeading, NJIconButton, NJPopover, NJText } from '@engie-group/fluid-design-system-react';
import { UMIcon, UMR } from '../../urbanmap/_components';

export function HomeRail({ onHome, flash }: { onHome: () => void; flash: (message: string) => void }) {
  const [open, setOpen] = useState(false);
  const titleId = useId();
  return (
    <nav className="pcv3-home-rail" aria-label="Navigation Plan">
      <NJPopover.Root opened={open} onOpen={setOpen} useFloatingOptions={{ placement: 'right-start', strategy: 'fixed' }}>
        <NJPopover.Interactions dismiss role={{ role: 'dialog' }}>
          <NJPopover.Anchor>
            <button type="button" className="pcv3-home-brand pcv3-brand-trigger"
              aria-label="Plan · accueil et changement d’application" aria-haspopup="dialog" aria-expanded={open}
              onClick={() => setOpen(!open)}>
              <span className="pav-plan-logo" style={{ width: UMR.size.logo + 8, height: UMR.size.logo + 8, background: 'var(--nj-core-color-teal-700)', color: UMR.white }}>Plan</span>
            </button>
          </NJPopover.Anchor>
          <NJPopover.Content focusManagerProps={{ modal: false }}>
            <div className="pcv3-app-switcher" aria-labelledby={titleId}>
              <NJButton variant="secondary" emphasis="subtle" icon="home" label="Accueil Plan"
                aria-current="page" onClick={() => { setOpen(false); onHome(); }} />
              <hr className="pcv3-app-switcher-divider" />
              <div className="pcv3-app-switcher-heading">
                <NJHeading as="h2" scale="xs" id={titleId}>Changer d’application</NJHeading>
                <NJIconButton label="Fermer le sélecteur d’application" icon="close" variant="tertiary" scale="sm"
                  onClick={() => setOpen(false)} />
              </div>
              <NJText scale="sm">Application actuelle : Plan</NJText>
              <NJButton href="/urbanmap" variant="secondary" icon="map" label="UrbanMap" />
              <NJButton href="/size2mix" variant="secondary" icon="hub" label="Size2Mix" />
            </div>
          </NJPopover.Content>
        </NJPopover.Interactions>
      </NJPopover.Root>
      <div className="pcv3-home-rail-footer">
        {[
          { icon: 'settings', label: 'Admin', message: 'Administration · à venir dans ce prototype' },
          { icon: 'mail', label: 'Contact', message: 'Contact · à venir dans ce prototype' },
          { icon: 'logout', label: 'Déconnexion', message: 'Déconnexion non disponible · vous êtes dans un prototype' },
        ].map((item) => <button key={item.label} type="button" className="pcv3-home-rail-action"
          onClick={() => flash(item.message)}>
          <UMIcon name={item.icon} size={UMR.size.railIcon} color={UMR.text} />
          <NJText as="span" scale="xs">{item.label}</NJText>
        </button>)}
      </div>
    </nav>
  );
}
